export const LAYOUT_TYPE = {
  SINGLE_COLUMN: 'single-column',
  DOUBLE_COLUMN: 'double-column',
  ISLAND: 'island',
} as const

export const STANDARD_AUTH_FORMS = {
  MAIN: 'main',
  LOGIN: 'login',
  REGISTER: 'register',
  FIREBASE: 'firebase',
  CHANGE_PASSWORD: 'change-password',
  RESET_PASSWORD: 'reset-password',
  PAIR: 'pair',
  JOINNUS: 'joinnus'
} as const

/**
 * Mutation-key prefix shared by the four auth-flow mutations in `useAuth`
 * (login, register, firebase, sso). Exists so AuthActor can ask React Query
 * "is any auth flow in flight?" via `useIsMutating({ mutationKey:
 * AUTH_FLOW_MUTATION_KEY })` — the activation failure modal must not render
 * over a live flow (register's onSuccess awaits the auto-login, so its
 * pending window spans both requests). The logout mutation deliberately does
 * NOT carry this prefix: the modal stays visible (buttons disabled) while
 * its own recover-access logout runs.
 */
export const AUTH_FLOW_MUTATION_KEY = ['auth-flow'] as const

export const LOGIN_ROUTE = '/login'

export const AUTH_FORM_TYPES = {
  REDIRECT: 'redirect',
  CALLBACK: 'callback',
  CONTAINER: 'container',
} as const

export const EMAIL_REGEX = /^[A-Z0-9._%+&-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export const NAME_MAX_LENGTH = 50